export default __webpack_public_path__ + "scene3_1_iconf63ff2.png";